import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=89e3006c&scoped=true&"
import script from "./Builder.vue?vue&type=script&lang=js&"
export * from "./Builder.vue?vue&type=script&lang=js&"
import style0 from "./Builder.vue?vue&type=style&index=0&id=89e3006c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e3006c",
  null
  
)

export default component.exports